const state = {
  isMostraSheetFooter : false,
  msgSheetFooter: null
}

const getters = {
  IS_MOSTRAR_SHEET: state => state.isMostraSheetFooter,
  MSG_SHEET: state => state.msgSheetFooter
}

const mutations = {
  SET_MOSTRAR_SHEET: (state, value) => {
    state.isMostraSheetFooter = value
  },
  SET_MSG_SHEET: (state, texto) => {
    state.msgSheetFooter = texto
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
} 


// WEBPACK FOOTER //
// ./src/store/modules/system/index.js